<template>
  <div class="card fine-card">
    <div class="fine-grid">
      <div class="field breakfast-field">
        <label>Petit déjeuner</label>
        <select v-model="form.prefered_breakfast">
          <option value="sweet">Sucré</option>
          <option value="salty">Salé</option>
          <option value="either">Les deux</option>
        </select>
      </div>

      <div class="field breakfast-field">
        <label class="label-with-help">
          Même petit déjeuner toute la semaine ?
          <span
            class="pref-help"
            tabindex="0"
            data-help="Oui : MMM choisit un petit déjeuner compatible avec vos préférences et le conserve toute la semaine. Non : MMM peut varier les recettes ; si vous avez choisi « Les deux », vous pouvez préciser les jours où vous préférez du sucré ou du salé."
          >?</span>
        </label>
        <div class="binary-options">
          <label :class="{ selected: form.same_breakfast_all_week === true }">
            <input type="radio" v-model="form.same_breakfast_all_week" :value="true"> Oui
          </label>
          <label :class="{ selected: form.same_breakfast_all_week === false }">
            <input type="radio" v-model="form.same_breakfast_all_week" :value="false"> Non
          </label>
        </div>
      </div>
      <div class="field" :class="{muted:isVegetarian}">
        <label>Repas avec viande / semaine</label>
        <select v-model.number="form.nb_meat_dish_per_week" :disabled="isVegetarian"><option v-for="n in 6" :key="'m'+(n-1)" :value="n-1">{{ n-1 }}</option></select>
      </div>
      <div class="field" :class="{muted:isVegetarian}">
        <label>Repas avec poisson / semaine</label>
        <select v-model.number="form.nb_fish_dish_per_week" :disabled="isVegetarian"><option v-for="n in 6" :key="'f'+(n-1)" :value="n-1">{{ n-1 }}</option></select>
      </div>
      <div class="field" :class="{muted:isVegetarian}">
        <label>Quand viande et poisson ?</label>
        <select v-model="form.preferences_for_when_to_eat_meat_and_fish" :disabled="isVegetarian"><option value="either">Peu importe</option><option value="lunch">Plutôt au déjeuner</option><option value="diner">Plutôt au dîner</option></select>
      </div>
    </div>

    <div
      v-if="!form.same_breakfast_all_week && form.prefered_breakfast === 'either'"
      class="breakfast-week"
    >
      <div class="breakfast-week-heading">
        <strong>Quand est-ce que je préfère un petit déjeuner sucré ou salé ?</strong>
        <span>Je peux choisir pour chaque jour, ou laisser « Peu importe ».</span>
      </div>
      <div class="breakfast-days">
        <div v-for="day in breakfastDays" :key="day.key" class="breakfast-day">
          <strong>{{ day.label }}</strong>
          <select v-model="form.breakfast_week_preferences[day.key]">
            <option value="either">Peu importe</option>
            <option value="sweet">Sucré</option>
            <option value="salty">Salé</option>
          </select>
        </div>
      </div>
    </div>

    <div v-if="isVegetarian" class="vegetarian-note">Les réglages viande et poisson ne s’appliquent pas avec une alimentation végétarienne.</div>

  </div>
</template>
<script>
import { userState } from "@/utils/store";
export default {
 name:"Preferences",
 props:{dietOption:{type:String,default:null},initialPreferences:{type:Object,default:null}},
 data(){
   const p={...(userState.me.consumer_account||{}),...(this.initialPreferences||{})};
   const defaultBreakfastWeek={
     monday:"either",tuesday:"either",wednesday:"either",thursday:"either",
     friday:"either",saturday:"either",sunday:"either"
   };
   return{
     saving:false,
     saved:false,
     breakfastDays:[
       {key:"monday",label:"Lundi"},{key:"tuesday",label:"Mardi"},
       {key:"wednesday",label:"Mercredi"},{key:"thursday",label:"Jeudi"},
       {key:"friday",label:"Vendredi"},{key:"saturday",label:"Samedi"},
       {key:"sunday",label:"Dimanche"}
     ],
     form:{
       prefered_breakfast:p.prefered_breakfast||"either",
       same_breakfast_all_week:!!p.same_breakfast_all_week,
       breakfast_week_preferences:{...defaultBreakfastWeek,...(p.breakfast_week_preferences||{})},
       nb_meat_dish_per_week:p.nb_meat_dish_per_week??4,
       nb_fish_dish_per_week:p.nb_fish_dish_per_week??3,
       preferences_for_when_to_eat_meat_and_fish:p.preferences_for_when_to_eat_meat_and_fish||"either"
     }
   }
 } ,
 mounted(){this.$emit("draft-change",JSON.parse(JSON.stringify(this.form)));},
 watch:{form:{deep:true,handler(value){this.$emit("draft-change",JSON.parse(JSON.stringify(value)));}}},
 computed:{isVegetarian(){return (this.dietOption ?? userState.me.consumer_account?.option)==="vegetarian";}},
 methods:{save(){this.$emit("save-request");}}
};
</script>
<style scoped>
.fine-card{padding:20px}
.label-with-help{display:flex!important;align-items:center;gap:6px}
.pref-help{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border:1px solid #6f9634;border-radius:50%;color:#466b22;font-size:11px;font-weight:800;cursor:help;position:relative}
.pref-help:hover::after,.pref-help:focus::after{content:attr(data-help);position:absolute;left:50%;bottom:calc(100% + 8px);transform:translateX(-50%);width:min(340px,78vw);padding:9px 11px;border-radius:8px;background:#26351b;color:#fff;font-size:12px;line-height:1.35;z-index:90}
.binary-options{display:flex;gap:8px}
.binary-options label{display:flex;align-items:center;gap:6px;padding:9px 13px;border:1px solid #d9dfd3;border-radius:999px;cursor:pointer;font-weight:700}
.binary-options label.selected{background:#edf6df;border-color:#7ab228;color:#466b22}
.breakfast-week{margin-top:18px;padding:16px;border:1px solid #dfe6d8;border-radius:12px;background:#f8faf5}
.breakfast-week-heading{display:grid;gap:3px;margin-bottom:12px}
.breakfast-week-heading strong{color:#466b22}
.breakfast-week-heading span{color:#5f6658;font-size:13px}
.breakfast-days{display:grid;grid-template-columns:repeat(7,minmax(100px,1fr));gap:8px}
.breakfast-day{display:grid;gap:6px}
.breakfast-day strong{font-size:13px}
.breakfast-day select{width:100%;padding:8px;border:1px solid #d9dfd3;border-radius:8px;background:#fff}
@media(max-width:1000px){.breakfast-days{grid-template-columns:repeat(4,minmax(100px,1fr))}}
@media(max-width:600px){.breakfast-days{grid-template-columns:1fr 1fr}}.fine-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}.field label{display:block;font-weight:700;margin-bottom:6px}.field select,.field input{width:100%;padding:10px;border:1px solid #d9dfd3;border-radius:8px;background:#fff}.muted{opacity:.5}.vegetarian-note{margin-top:12px;color:#5f6658}.actions{display:flex;justify-content:flex-end;align-items:center;gap:12px;margin-top:18px}.actions span{color:#3c6610;font-weight:700}@media(max-width:800px){.fine-grid{grid-template-columns:1fr}}
</style>